import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { getAutoComplete } from "../services/bookService";

export default function MainHeader() {

    const [fontSize, setFontSize] = useState(16);

    useEffect(() => {
        document.documentElement.style.setProperty('--font-size-base', `${fontSize}px`);
    }, [fontSize]);

    const increaseFontSize = () => {
        setFontSize(prevSize => Math.min(prevSize + 2, 20));
    };

    const decreaseFontSize = () => {
        setFontSize(prevSize => Math.max(prevSize - 2, 14));
    };

    const resetFontSize = () => {
        setFontSize(16);
    };

    const [query, setQuery] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const lastNavigatedQuery = useRef('');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
   


    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            const trimmed = query.trim();

            if (trimmed && location.pathname !== `/search/${trimmed}`) {
                if (lastNavigatedQuery.current !== trimmed) {
                    lastNavigatedQuery.current = trimmed;
                    navigate(`/search/${trimmed}`);
                }
            } else if (!trimmed && location.pathname !== '/') {
                if (lastNavigatedQuery.current !== '') {
                    lastNavigatedQuery.current = '';
                    navigate('/');
                }
            }
        }, 800);

        return () => clearTimeout(delayDebounce);
    }, [query, navigate, location.pathname]);


    useEffect(() => {
        const trimmed = query.trim();

        if (trimmed.length >= 2) {
            const fetchSuggestions = setTimeout(async () => {
                try {
                    const response = await getAutoComplete({
                        search: trimmed,
                    });

                    setSuggestions(response.data);
                } catch (error) {
                    console.error("Error fetching suggestions:", error);
                    setSuggestions([]);
                }
            }, 500);

            return () => clearTimeout(fetchSuggestions);
        } else {
            setSuggestions([]);
        }
    }, [query]);


    const [theme, setTheme] = useState(sessionStorage.getItem('theme') || 'light');

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        sessionStorage.setItem('theme', theme); // Save theme to localStorage
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };



    return (
        <>
            <div className="newHeader--main">
                <div className="container space-container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                                <div className="logo">
                                    <NavLink to="/home" className="light">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/logo_light_mode.png`} alt="logo" />
                                    </NavLink>
                                    <NavLink to="/home" className="dark"><img src={`${process.env.PUBLIC_URL}/assets/images/logo_dark_mode.png`} alt="logo" /></NavLink>
                                </div>
                                <div className="searchSec">
                                    <div className="d-flex position-relative">
                                        <input
                                            className="form-control me-2"
                                            type="search"
                                            value={query}
                                            onChange={(e) => setQuery(e.target.value)}
                                            onFocus={() => setShowSuggestions(true)}
                                            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                            placeholder="Search Books"
                                            aria-label="Search"
                                        />
                                        <i class="fas fa-search position-absolute main-search-icon"></i>

                                        {showSuggestions && suggestions?.length > 0 && (
                                            <ul className="search-option position-absolute w-100 bg-white border z-10">
                                                {suggestions.map((item, index) => (
                                                    <li
                                                        key={index}
                                                        className="px-4 py-2 search_li cursor-pointer"
                                                        onClick={() => {
                                                            setQuery(item);
                                                            setShowSuggestions(false);
                                                        }}
                                                    >
                                                        {item}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                                <div className="rightSec">
                                    <NavLink className="meri-pustake d-none" to="/library">Meri Pustake</NavLink><span className="dividerSec d-none">
                                        |
                                    </span>
                                    <div className="mobileApp d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#epustakalaya">
                                        <img className='mobile-icon light' src={`${process.env.PUBLIC_URL}/assets/images/elements/smartphone.png`} alt='Mobile Icon' />
                                        <img className='mobile-icon dark' src={`${process.env.PUBLIC_URL}/assets/images/elements/smartphone_light.png`} alt='Mobile Icon' />
                                    </div>
                                    <span className="dividerSec">
                                        |
                                    </span>
                                    <div className="themeSec">

                                        <div onClick={toggleTheme} style={{ cursor: 'pointer' }}>
                                            <button className='btn f_increase view-all-btnn'>{theme === 'light' ? <i className="fas fa-sun"></i> : <i className="fas fa-moon"></i>}</button>
                                        </div>
                                    </div>

                                    <span className="dividerSec">
                                        |
                                    </span>

                                    <div className="textDropdwn">


                                        <button className='btn f_increase view-all-btnn' onClick={increaseFontSize}>A +</button>
                                        <button className='btn f_increase  view-all-btnn' onClick={resetFontSize}>A</button>
                                        <button className='btn f_increase  view-all-btnn' onClick={decreaseFontSize}>A -</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
